import { render, staticRenderFns } from "./modalOrdenesComponent.vue?vue&type=template&id=dd6eabb0"
import script from "./modalOrdenesComponent.vue?vue&type=script&lang=js"
export * from "./modalOrdenesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports